import { useTranslation } from "react-i18next";
import { FCC } from "types";

import { FriendsWithBenefitsRates } from "@/components/FriendsWithBenefits/FriendsWithBenefitsRates";
import { Button } from "@/components/Interface/Button/Button";
import { useIsDesktop } from "@/hooks/useIsDesktop";

const NextSteps: FCC = () => {
  const { t } = useTranslation();

  return (
    <>
      <h2 className="mb-6 text-secondary-100">
        {t("friendsWithBenefits.welcome.nextSteps")}
      </h2>
      <ol className="mb-4 ml-4 list-inside list-decimal">
        <li>{t("friendsWithBenefits.welcome.steps.register")}</li>
        <li>{t("friendsWithBenefits.welcome.steps.order")}</li>
        <li>{t("friendsWithBenefits.welcome.steps.benefit")}</li>
      </ol>
    </>
  );
};

export const WelcomeFriendsWithBenefitsContent: FCC<{
  tribeDiscount: number;
  isCTAClicked: boolean;
  onCTAClick: ((value: boolean) => void) | (() => PromiseLike<string>);
}> = ({ tribeDiscount, isCTAClicked, onCTAClick }) => {
  const { t } = useTranslation();
  const isDesktop = useIsDesktop();

  const handleCTAClick = () => onCTAClick(!isCTAClicked);

  return (
    <>
      {isDesktop ? (
        <div className="rounded-xl bg-white p-6 shadow-primary">
          <NextSteps />
          <hr className="mx-auto my-4 h-1 rounded-sm border-primary-50 md:my-10" />
          <FriendsWithBenefitsRates tribeDiscount={tribeDiscount}>
            <div className="flex flex-col">
              <p className="mb-2 pt-4 text-base font-semibold">
                {t("friendsWithBenefits.startSaving")}
              </p>

              <Button fullWidth className="accent" onClick={handleCTAClick}>
                {t("friendsWithBenefits.welcome.joinNow")}
              </Button>
            </div>
          </FriendsWithBenefitsRates>
        </div>
      ) : (
        <div className="flex flex-col">
          <div className="mb-8 w-full rounded-xl bg-white p-4 shadow-primary">
            <FriendsWithBenefitsRates tribeDiscount={tribeDiscount} isMobile>
              <div className="flex flex-col">
                <p className="pt-4 text-base font-semibold">
                  {t("friendsWithBenefits.startSaving")}
                </p>
              </div>
            </FriendsWithBenefitsRates>
          </div>
          <div className="w-full rounded-xl bg-white p-4">
            <NextSteps />
            <Button className="accent" onClick={handleCTAClick}>
              {t("friendsWithBenefits.welcome.joinNow")}
            </Button>
          </div>
        </div>
      )}
    </>
  );
};
